(function () {
  // GA4 : pse_barrette_prompt (dialogue ouvert au clic sur Ajouter au panier),
  // pse_barrette_choice (choix validé, fiche ou panier). Param `placement` = pdp|drawer|page.
  function track(name, payload) {
    try {
      if (window.gtag) window.gtag('event', name, payload);
      if (window.dataLayer) window.dataLayer.push(Object.assign({ event: name }, payload));
    } catch (err) {}
  }

  function openDialog(dialog) {
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
  }

  function closeDialog(dialog) {
    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
  }

  function cartAddUrl() {
    return (window.routes && window.routes.cart_add_url) || '/cart/add';
  }

  function initProduct(root) {
    if (root.dataset.scartPseReady === 'true') return;

    var form = document.getElementById(root.dataset.formId);
    var dialog = root.querySelector('.scart-pse-dialog');
    if (!form || !dialog) return;

    root.dataset.scartPseReady = 'true';
    var confirmButton = root.querySelector('[data-scart-pse-confirm]');
    var current = root.querySelector('[data-scart-pse-current]');
    var error = root.querySelector('[data-scart-pse-error]');
    var submitButton = form.querySelector('[name="add"]');
    var productHandle = root.dataset.productHandle;
    // null = pas encore choisi, '' = interrupteur inclus, sinon id de variante de la barrette
    var choice = null;
    var fromSubmit = false;
    var passThrough = false;

    function checked() {
      return root.querySelector('[data-scart-pse-option]:checked');
    }

    function showDialog(viaSubmit) {
      fromSubmit = viaSubmit;
      confirmButton.textContent = viaSubmit ? confirmButton.dataset.labelAdd : confirmButton.dataset.labelSave;
      confirmButton.disabled = !checked();
      openDialog(dialog);
    }

    form.addEventListener(
      'submit',
      function (event) {
        if (passThrough) {
          passThrough = false;
          return;
        }

        if (choice === null) {
          event.preventDefault();
          event.stopImmediatePropagation();
          track('pse_barrette_prompt', { placement: 'pdp', product_handle: productHandle });
          showDialog(true);
          return;
        }

        if (choice === '') return;

        // Ajoute la barrette, puis relance la soumission normale de l'échappement :
        // le formulaire Dawn rafraîchit ensuite le panier avec les deux lignes.
        event.preventDefault();
        event.stopImmediatePropagation();
        if (submitButton) submitButton.setAttribute('aria-disabled', 'true');
        if (error) error.hidden = true;

        fetch(cartAddUrl() + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(choice), quantity: 1, properties: { _scart_source: 'pse_pdp' } }],
          }),
        })
          .then(function (response) {
            if (!response.ok) throw new Error('PSE panel add failed');
          })
          .catch(function (err) {
            if (error) error.hidden = false;
            console.error(err);
          })
          .then(function () {
            if (submitButton) submitButton.removeAttribute('aria-disabled');
            passThrough = true;
            form.requestSubmit(submitButton);
          });
      },
      true
    );

    root.addEventListener('change', function (event) {
      if (event.target.matches('[data-scart-pse-option]')) confirmButton.disabled = false;
    });

    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-scart-pse-open]')) {
        showDialog(false);
        return;
      }

      if (event.target.closest('[data-scart-pse-close]')) {
        closeDialog(dialog);
        return;
      }

      var skip = event.target.closest('[data-scart-pse-skip]');
      if (skip || event.target.closest('[data-scart-pse-confirm]')) {
        if (skip) root.querySelector('.scart-pse-option--none input').checked = true;
        var input = checked();
        if (!input) return;
        choice = input.value;
        if (current) current.textContent = input.dataset.label;
        root.classList.toggle('has-barrette', choice !== '');
        track('pse_barrette_choice', {
          placement: 'pdp',
          product_handle: productHandle,
          choice: input.dataset.handle,
        });
        closeDialog(dialog);
        if (fromSubmit) form.requestSubmit(submitButton);
      }
    });
  }

  function bootProducts(scope) {
    var roots = (scope || document).querySelectorAll('[data-scart-pse]');
    for (var i = 0; i < roots.length; i++) initProduct(roots[i]);
  }

  // Panier : ajout de la barrette depuis le rappel sous l'échappement.
  async function addFromCart(root, button) {
    var select = root.querySelector('[data-scart-pse-cart-select]');
    var status = root.querySelector('[data-scart-pse-cart-status]');
    if (!select || !select.value || button.disabled) return;
    button.disabled = true;

    var cartDrawer = document.querySelector('cart-drawer');
    var inDrawer = !!root.closest('cart-drawer');
    var body = {
      items: [{ id: Number(select.value), quantity: 1, properties: { _scart_source: 'pse_cart' } }],
    };
    if (inDrawer && cartDrawer) {
      body.sections = cartDrawer.getSectionsToRender().map(function (section) {
        return section.id;
      });
      body.sections_url = window.location.pathname;
    }

    track('pse_barrette_choice', {
      placement: inDrawer ? 'drawer' : 'page',
      product_handle: root.dataset.productHandle,
      choice: select.options[select.selectedIndex].dataset.handle,
    });

    try {
      var response = await fetch(cartAddUrl() + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      var result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || 'Cart add failed');

      if (inDrawer && cartDrawer && result.sections) {
        cartDrawer.renderContents(result);
      } else {
        window.location.reload();
      }
    } catch (err) {
      button.disabled = false;
      if (status) {
        status.textContent =
          document.documentElement.lang.toLowerCase().indexOf('fr') === 0
            ? "Impossible d'ajouter la barrette. Réessayez."
            : 'Unable to add the switch panel. Please try again.';
      }
      console.error(err);
    }
  }

  if (!window.scartPseCartReady) {
    window.scartPseCartReady = true;
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-scart-pse-cart-add]');
      if (!button) return;
      event.preventDefault();
      addFromCart(button.closest('[data-scart-pse-cart]'), button);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bootProducts(document);
    });
  } else {
    bootProducts(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    bootProducts(event.target);
  });
})();
